import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { mtsdBannerClick } from '@shared/lib/gtm';
import { PaymentButton } from '@shared/ui/atoms';
import mtsdBannerDesktop from '../assets/mtsd-banner-desktop.webp';
import mtsdBannerMobile from '../assets/mtsd-banner-mobile.webp';
const MTSDPromoBanner: FC = () => {
  const handleBannerClick = e => {
    e?.stopPropagation();
    mtsdBannerClick();
  };
  return <MTSDPromoBannerWrapper href="https://mtsdengi.ru/karti/uprid/payment-mts-cyber-1/?&webview=true&utm_source=cvm_cyber&utm_medium=general&utm_campaign=banner&utm_content=cashback_20" target="_blank" onClick={handleBannerClick}>
      <picture>
        <source media="(min-width: 1024px)" srcSet={mtsdBannerDesktop} width={360} height={320} />
        <img src={mtsdBannerMobile} alt="Кешбэк при оплате картой МТС Деньги" width={335} height={204} />
      </picture>
      <ButtonWrapper>
        <PaymentButton type="button" title="Это мне надо" height={40} />
      </ButtonWrapper>
    </MTSDPromoBannerWrapper>;
};
export default MTSDPromoBanner;
const MTSDPromoBannerWrapper = /*#__PURE__*/styled('a')({
  name: "MTSDPromoBannerWrapper",
  class: "m1tgg318",
  propsAsIs: false
});
const Mobile = /*#__PURE__*/styled('div')({
  name: "Mobile",
  class: "m1u5bb0u",
  propsAsIs: false
});
const Tablet = /*#__PURE__*/styled('div')({
  name: "Tablet",
  class: "t18rg83o",
  propsAsIs: false
});
const Desktop = /*#__PURE__*/styled('div')({
  name: "Desktop",
  class: "d1aleyiu",
  propsAsIs: false
});
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b193vn05",
  propsAsIs: false
});

require("./MTSDPromoBanner.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MTSDPromoBanner.tsx");